import baseStyled,{ThemedStyledInterface} from 'styled-components';
import { HomeMenuTheme } from './themes/types';
import Icon from '@plasma/ui.general.icon';

const styled = baseStyled as ThemedStyledInterface<HomeMenuTheme>;

export const StyledIcon = styled(Icon)`
  background: ${(props) => props.theme.mode.HomeMenu.backgroundIconColor};  
  color: ${(props) => props.theme.mode.HomeMenu.textColor};
  border-radius: 15px; 
  border: 2px solid #267DAC;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;  /* Ensure full width of the container */
  box-sizing: border-box;  /* Include padding and border in the element's total width and height */
  overflow-x: hidden;  /* Prevent horizontal overflow */
  overflow-y: auto;  /* Allow vertical scrolling if needed */
`;

export const Header = styled.div`
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  width: 100%;  /* Ensure the header takes full width */
`;

export const SubHeader = styled.div`
  font-size: 16px;
  font-weight: bold;
  width: 100%;  /* Ensure the subheader takes full width */
  text-align: center;  /* Center the text */
`;

export const BoxMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10vw 10vw 10vw 10vw;
  box-sizing: border-box;  /* Include padding and border in the element's total width and height */
  justify-content: center;
`;

export const BoxMenuRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  flex-wrap: wrap;  /* Allow items to wrap to the next line */
  box-sizing: border-box;  /* Include padding and border in the element's total width and height */
  
`;
